<template>
<div class="h-100">
  <component
    v-if="(interactionInstance && currentItem) || interactionError"
    :is="currentInteractionWrapper"
    v-bind="currentInteractionWrapperProps"
    :style="injectCurrentVariant()"
  >
  </component>
  <context-menu
    class="ix-container__context-menu"
    :product-type="interactionInstance && interactionInstance.productType"
    @change-language="changeLanguage"
  />
</div>
</template>
<script>
/**
 * Wrapper component for different types/parts of interaction UI
 * loads interaction instance, items, translations and decides which container to render
 * types: Styled (uses whole page with color), Main
 */
import { mapGetters, mapActions } from 'vuex'
import { TEXT_TYPES } from '@/constants/i18n'
import {
  INTER_ITEM,
  STYLE_ITEM
} from '@/constants/items'

import MainInteractionContainer from '@/containers/Interaction/MainInteractionContainer'
import StyledInteractionContainer from '@/containers/Interaction/StyledInteractionContainer'
import NavigationContainer from '@/containers/NavigationContainer'
import InteractionErrorContainer from '@/containers/Error/InteractionErrorContainer'

import colorVariantMixin from '@/components/mixins/colorVariantMixin'
import contextMenu from '@/components/ui/contextMenu'

export default {
  name: 'InteractionContainer',
  components: {
    MainInteractionContainer,
    StyledInteractionContainer,
    InteractionErrorContainer,
    contextMenu
  },
  mixins: [
    colorVariantMixin
  ],
  props: {
    interactionInstanceToken: {
      type: String
    }
  },
  data() {
    return {
      showLang: true,
    }
  },
  computed: {
    ...mapGetters([
      'interactionInstance',
      'currentItem',
      'currentItemNumber',
      'interactionError',
      'locale'
    ]),
    isStyledItem() {
      return this.currentItem && this.currentItem.properties && this.currentItem.properties.find(prop => prop.name === STYLE_ITEM)
    },
    isInterItem() {
      return this.currentItem && this.currentItem.properties && this.currentItem.properties.find(prop => prop.name === INTER_ITEM)
    },
    currentInteractionWrapper() {
      if(this.interactionError) {
        return InteractionErrorContainer
      }
      if(this.isStyledItem) {
        return StyledInteractionContainer
      }
      if(this.isInterItem) {
        return NavigationContainer
      }
      return MainInteractionContainer
    },
    currentInteractionWrapperProps() {
      return {
        interactionInstanceToken: this.interactionInstanceToken,
        interactionInstance: this.interactionInstance
      }
    }
  },
  methods: {
    ...mapActions([
      'setLocale',
      'fetchInteractionInstance',
      'fetchTranslations',
      'fetchInstanceItems',
      'setLoadingUntilResolved'
    ]),
    changeLanguage(lang) {
      const url = new URL(window.location.href);
      url.searchParams.set("locale", lang);
      window.location.href = url.toString();
    },
    hideLang() {
      this.showLang = false
    }
  },
  async mounted() {
    await this.fetchInteractionInstance({ interactionInstanceToken: this.interactionInstanceToken })
    if(this.interactionInstance) {
      this.setLoadingUntilResolved([
        this.fetchInstanceItems({ interactionInstanceToken: this.interactionInstanceToken }),
        this.fetchTranslations({ textType: TEXT_TYPES.ITEM, interactionToken: this.interactionInstanceToken }),
        this.fetchTranslations({ textType: TEXT_TYPES.CHOICE, interactionToken: this.interactionInstanceToken }),
        this.fetchTranslations({ textType: TEXT_TYPES.INTERACTION_BASE }).then(() => {
          document.title = this.$t('INTERACTION_BASE_INTERACTION_APPLICATION_TITLE_TEXT')
        })
      ])
    }


  }
}
</script>
<style lang="scss">
.ix-container__context-menu {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000000;
  font-size: 15px;

}
</style>